import {
  Box,
  Circle,
  IconButton,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Tooltip,
  useBoolean
} from "@chakra-ui/react";
import { RiSoundModuleLine } from "react-icons/ri";

type Props = {
  qtdFiltersActive: number;
  isFilterDisabled?: boolean;
  children: React.ReactNode;
};

export const FilterPopover = ({
  qtdFiltersActive,
  children,
  isFilterDisabled = false
}: Props) => {
  const [isEditing, setIsEditing] = useBoolean();

  return (
    <>
      <Popover
        offset={[180, -35]}
        isOpen={!isFilterDisabled && isEditing}
        onOpen={setIsEditing.on}
        onClose={setIsEditing.off}
        closeOnBlur={true}
        isLazy
        lazyBehavior="keepMounted"
      >
        <Box>
          <PopoverTrigger>
            <Box position="relative">
              <Tooltip label="Busca avançada" placement="top">
                <IconButton
                  size="sm"
                  aria-label="Filtro avançado"
                  icon={<RiSoundModuleLine />}
                  colorScheme="gray"
                  onClick={setIsEditing.toggle}
                  isDisabled={isFilterDisabled}
                />
              </Tooltip>
              {qtdFiltersActive > 0 && (
                <Circle
                  position="absolute"
                  right="-3"
                  top="-1"
                  fontSize="xx-small"
                  bgColor="main.400"
                  color="white"
                  size="4"
                  zIndex={1}
                >
                  {qtdFiltersActive}
                </Circle>
              )}
            </Box>
          </PopoverTrigger>
          <PopoverContent>
            <PopoverBody bgColor="white" _dark={{ bgColor: "gray.1000" }}>
              {children}
            </PopoverBody>
          </PopoverContent>
        </Box>
      </Popover>
    </>
  );
};
